var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$currentUser.role == "user" || _vm.$currentUser.role == "account"
      ? _c("div", { staticClass: "main-content bg-white" }, [
          _c("span", { staticClass: "alert-danger" }, [
            _vm._v("У вас нет доступа к этой странице.")
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$currentUser.role != "user" && _vm.$currentUser.role != "account"
      ? _c(
          "div",
          { staticClass: "main-content bg-white" },
          [
            _vm._m(0),
            _vm._v(" "),
            _vm.$currentUser.role == "admin"
              ? _c("div", { staticClass: "row mb-2" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2" },
                    [
                      _c(
                        "b-btn",
                        {
                          directives: [
                            {
                              name: "b-modal",
                              rawName: "v-b-modal.createUser",
                              modifiers: { createUser: true }
                            }
                          ],
                          staticClass: "mainButton filterComponent",
                          staticStyle: { "white-space": "nowrap" },
                          attrs: { size: "sm", variant: "success" }
                        },
                        [
                          _vm._v(
                            "\n                    Создать пользователя\n                    "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.$currentUser.role === "admin"
                    ? _c(
                        "div",
                        { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2" },
                        [
                          _c(
                            "b-btn",
                            {
                              staticClass: "mainButton filterComponent",
                              staticStyle: { "white-space": "nowrap" },
                              attrs: { size: "sm", variant: "success" },
                              on: { click: _vm.redirectToUserGroups }
                            },
                            [
                              _vm._v(
                                "\n                Группы пользователей\n              "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$currentUser.role == "admin"
              ? _c("div", { staticClass: "row mb-2" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2" },
                    [
                      _c(
                        "v-select",
                        {
                          attrs: {
                            options: _vm.roles,
                            required: "",
                            clearable: false,
                            searchable: false,
                            placeholder: "Роль",
                            multiple: ""
                          },
                          model: {
                            value: _vm.selectedRole,
                            callback: function($$v) {
                              _vm.selectedRole = $$v
                            },
                            expression: "selectedRole"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              attrs: { slot: "no-options" },
                              slot: "no-options"
                            },
                            [_vm._v("Совпадений не найдено.")]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-sm-5 col-md-3 col-lg-2 col-xl-2 mb-2 applyButton"
                    },
                    [
                      _c(
                        "b-input-group",
                        { staticClass: "filterComponent" },
                        [
                          _c("div"),
                          _vm._v(" "),
                          _c(
                            "b-input-group-append",
                            [
                              _c(
                                "b-btn",
                                {
                                  staticClass: "mainButton",
                                  staticStyle: {
                                    "margin-right": "4px",
                                    "border-top-left-radius": "0.2rem",
                                    "border-bottom-left-radius": "0.2rem"
                                  },
                                  attrs: {
                                    size: "sm",
                                    text: "Search",
                                    variant: "success"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.getUsers({
                                        sortBy: _vm.sortBy,
                                        sortDesc: _vm.sortDesc
                                      })
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                            Применить\n                            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-btn",
                                {
                                  staticClass: "mainButton",
                                  attrs: {
                                    size: "sm",
                                    variant: "outline-danger"
                                  },
                                  on: { click: _vm.resetFilters }
                                },
                                [
                                  _vm._v(
                                    "Очистить\n                            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12" }, [
                _vm.$currentUser.role == "leader" && _vm.users.length == 0
                  ? _c("span", { staticClass: "alert-info" }, [
                      _vm._v("Подчиненные пока не назначены.")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$currentUser.role == "admin" ||
                (_vm.$currentUser.role == "leader" && _vm.users.length > 0)
                  ? _c(
                      "div",
                      [
                        _c("b-table", {
                          attrs: {
                            hover: "",
                            responsive: "",
                            bordered: "",
                            small: "",
                            items: _vm.users,
                            fields:
                              _vm.$currentUser.role == "admin"
                                ? _vm.fields
                                : _vm.leaderFields,
                            "no-local-sorting": "",
                            "sort-by": _vm.sortBy,
                            "sort-desc": _vm.sortDesc,
                            "sort-direction": _vm.sortDirection
                          },
                          on: {
                            "update:sortBy": function($event) {
                              _vm.sortBy = $event
                            },
                            "update:sort-by": function($event) {
                              _vm.sortBy = $event
                            },
                            "sort-changed": _vm.getUsers,
                            "update:sortDesc": function($event) {
                              _vm.sortDesc = $event
                            },
                            "update:sort-desc": function($event) {
                              _vm.sortDesc = $event
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "cell(actions)",
                                fn: function(row) {
                                  return [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "btn btn-warning",
                                        attrs: { size: "sm" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.edit(row)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "icon-fa icon-fa-edit"
                                        })
                                      ]
                                    )
                                  ]
                                }
                              },
                              {
                                key: "cell(subordinates)",
                                fn: function(row) {
                                  return [
                                    _vm._l(row.item.subordinates, function(
                                      item,
                                      index
                                    ) {
                                      return _c("span", [
                                        index ==
                                        row.item.subordinates.length - 1
                                          ? _c("span", [
                                              _vm._v(_vm._s(item.name))
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        index >= 0 &&
                                        index < row.item.subordinates.length - 1
                                          ? _c("span", [
                                              _vm._v(_vm._s(item.name) + ", ")
                                            ])
                                          : _vm._e()
                                      ])
                                    }),
                                    _vm._v(" "),
                                    row.item.subordinates == 0
                                      ? _c("div")
                                      : _vm._e()
                                  ]
                                }
                              },
                              {
                                key: "cell(leader)",
                                fn: function(row) {
                                  return [
                                    _vm._l(row.item.leader, function(
                                      item,
                                      index
                                    ) {
                                      return _c("div", [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(item) +
                                            "\n                            "
                                        )
                                      ])
                                    }),
                                    _vm._v(" "),
                                    row.item.leader == 0 ? _c("div") : _vm._e()
                                  ]
                                }
                              },
                              {
                                key: "cell(user_group)",
                                fn: function(row) {
                                  return [
                                    row.item.user_group
                                      ? _c("div", [
                                          _vm._v(
                                            _vm._s(row.item.user_group.title)
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                }
                              },
                              {
                                key: "cell(deactivated)",
                                fn: function(row) {
                                  return [
                                    row.item.deactivated == 0
                                      ? _c("div", [
                                          _c("i", {
                                            staticClass:
                                              "icon-fa icon-fa-circle text-success"
                                          })
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    row.item.deactivated == 1
                                      ? _c("div", [
                                          _c("i", {
                                            staticClass:
                                              "icon-fa icon-fa-circle text-danger"
                                          })
                                        ])
                                      : _vm._e()
                                  ]
                                }
                              },
                              {
                                key: "cell(role)",
                                fn: function(row) {
                                  return [
                                    row.item.role == "admin"
                                      ? _c("div", [
                                          _vm._v(
                                            "\n                                Админ\n                            "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    row.item.role == "user"
                                      ? _c("div", [
                                          _vm._v(
                                            "\n                                Пользователь\n                            "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    row.item.role == "leader"
                                      ? _c("div", [
                                          _vm._v(
                                            "\n                                Лидер\n                            "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    row.item.role == "account"
                                      ? _c("div", [
                                          _vm._v(
                                            "\n                                Аккаунт\n                            "
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3207163639
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "userCreateModal",
                attrs: {
                  id: "createUser",
                  size: "md",
                  title: "Создать пользователя",
                  "hide-footer": ""
                },
                on: { hidden: _vm.hideCreateModal }
              },
              [_c("CreateUserModal")],
              1
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "userEditModal",
                attrs: {
                  id: "userEditModal",
                  size: "md",
                  title: "Редактировать пользователя",
                  "hide-footer": ""
                },
                on: { hidden: _vm.hideCreateModal }
              },
              [_c("EditUserModal", { attrs: { user: _vm.selectedUser } })],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [_vm._v("Пользователи")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c62d55a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c62d55a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/front/Users.vue
// module id = 1047
// module chunks = 0